const accessKeysHR = {
    "view": {
        "title": "Pristupni ključevi",
        "form": {
            "label": {
                "accessKeyId": "ID pristupnog ključa",
                "secretAccessKey": "Tajni pristupni ključ"
            },
            "button": {
                "hide": "Sakrij",
                "reveal": "Otkrij"
            },
            "message": {
                "accessKeyIdCopied": "ID pristupnog ključa kopiran u međuspremnik!",
                "secretAccessKeyCopied": "Tajni pristupni ključ kopiran u međuspremnik!"
            }
        },
        "uploadInstructions": {
            "title": "Upute",
            "step1": {
                "title": "Korak 1 - Preuzmite alat za prijenos",
                "description": "Preuzmite <1>Cyberduck</1> alat."
            },
            "step2": {
                "title": "Korak 2 - Napravite kopiju tablice za prijenos i spremite datoteku okidača",
                "descriptionPoint1": "Kopirajte ovu <1><strong>TABLICU</strong></1> na vaš GOOGLE DRIVE.",
                "descriptionPoint2": "Spremite ovu <1><strong>DATOTEKU OKIDAČA</strong></1> na vaše računalo ili u oblak."
            },
            "step3": {
                "title": "Korak 3 - Uspostavite vezu",
                "descriptionPoint1": "Otvorite Cyberduck alat.",
                "descriptionPoint2": "U donjem lijevom kutu kliknite na + ikonu. (Dodajte novu oznaku).",
                "descriptionPoint3": "Unesite sljedeće vjerodajnice:",
                "descriptionPoint4": "ID pristupnog ključa: ",
                "descriptionPoint5": "Tajni pristupni ključ: ",
                "descriptionPoint6": "Vaša S3 mapa: ",
                "descriptionPoint7": "Vaša S3 putanja: ",
                "descriptionPoint8": "Slijedite ove korake:"
            },
            "step4": {
                "title": "Korak 4 - Ispunite metapodatke",
                "description": "Ispunite metapodatke prema uputama iz našeg Centra za pomoć."
            },
            "step5": {
                "title": "Korak 5 - Datoteke i žanrovi",
                "descriptionPoint1": "Prenesite svoju <1>metadata.csv</1> datoteku i sve audio <3>(.wav)</3> i <5>slikovne (.jpg)</5> datoteke, <7> NE (.jpeg)</7>",
                "descriptionPoint2": "<strong>JPG datoteke</strong> moraju biti <strong>3000x3000 px, maksimalna veličina datoteke 4MB</strong>",
                "descriptionPoint3": "Audio datoteke moraju biti samo <strong>wav, 16 bit, 44.1 khz</strong>",
                "descriptionPoint4": "Nazivi korijenskih datoteka moraju biti jedna riječ",
                "descriptionPoint5": "<strong>VAŽNO:</strong> Obratite pažnju na <2><strong>ML plesne žanrove</strong></2> i podudaranje u trgovinama kao što je Beatport."
            },
            "step6": {
                "title": "Korak 6 - Prijenos okidača",
                "description": "Nakon što su sve datoteke prenesene, molimo prenesite ovu praznu datoteku okidača <1>“last.zzz”</1>. Pratite svoj email za bilo kakve obavijesti."
            },
            "step7": {
                "title": "Savjet - Testirajte s nama prije prijenosa",
                "description": "Slobodno kontaktirajte naš tim za podršku s bilo kakvim pitanjima u vezi ovog načina kreiranja izdanja. Ovo je vrlo jednostavan proces koji se oslanja na robusnije tehnologije kao što je AWS S3 i ne oslanja se na tehnologije preglednika. Međutim, zahtijeva da vaši metapodaci budu 100 % točni. Music Link tim može testirati prijenos nekoliko izdanja za vas s vašim metapodacima kako bi otkrio moguće probleme."
            }
        }
    }
};

export default accessKeysHR;